import decode from 'jwt-decode';

function getTokenExpirationDate(token) {
  const decoded = decode(token);

  if (!decoded.exp) {
    return null;
  }

  const date = new Date(0); // The 0 here is the key, which sets the date to the epoch
  date.setUTCSeconds(decoded.exp);

  return date;
}

export function isTokenValid(token) {
  try {
    decode(token);
    return true;
  } catch (e) {
    return false;
  }
}

export function isTokenExpired(token) {
  const date = getTokenExpirationDate(token);

  if (date === null) {
    return false;
  }

  const offsetSeconds = 0;

  return !(date.valueOf() > (new Date().valueOf() + (offsetSeconds * 1000)));
}

export function getUserFromToken(token) {
  const decoded = decode(token);
  return {
    id: decoded.id,
    firstName: decoded.first_name,
    lastName: decoded.last_name,
    type: decoded.type,
    email: decoded.email,
    companyId: decoded.company_id,
    isClient: decoded.is_client,
    locale: decoded.locale,
  };
}
